import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseInMemoryCachedRepository } from '@lib/domain-common';
export var FORM_RELEASE_IN_MEMORY_CACHED = 'FORM_RELEASE_IN_MEMORY_CACHED';
export var FormReleaseInMemoryWebCached = /*#__PURE__*/function (_BaseInMemoryCachedRe) {
  _inherits(FormReleaseInMemoryWebCached, _BaseInMemoryCachedRe);

  var _super = _createSuper(FormReleaseInMemoryWebCached);

  function FormReleaseInMemoryWebCached() {
    _classCallCheck(this, FormReleaseInMemoryWebCached);

    return _super.apply(this, arguments);
  }

  return FormReleaseInMemoryWebCached;
}(BaseInMemoryCachedRepository);